export const isSSR = () => import.meta.server || typeof window === 'undefined';
